import { render, staticRenderFns } from "./PearlieSue.vue?vue&type=template&id=3773989e&"
import script from "./PearlieSue.vue?vue&type=script&lang=js&"
export * from "./PearlieSue.vue?vue&type=script&lang=js&"
import style0 from "./PearlieSue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports